import { message } from 'antd';

/** MUI Dialog uses z-index 1300; antd message defaults to 1010. */
const MESSAGE_LAYER_STYLE_ID = 'kambria-ant-message-above-modal';

export const ensureRevenueSharingMessageLayer = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(MESSAGE_LAYER_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = MESSAGE_LAYER_STYLE_ID;
  style.textContent = '.ant-message { z-index: 1400 !important; }';
  document.head.appendChild(style);
};

const withLayer = (fn) => (content, duration) => {
  ensureRevenueSharingMessageLayer();
  return fn(content, duration);
};

export const revenueSharingMessage = {
  success: withLayer(message.success),
  error: withLayer(message.error),
  warning: withLayer(message.warning),
};
